import { useEffect } from 'react';

const MobileScrollFix: React.FC = () => {
  useEffect(() => {
    // Fix for iOS Safari viewport issues - optimized to avoid forced reflows
    let rafId: number | null = null;
    let ticking = false;

    const setViewportHeight = () => {
      if (!ticking) {
        rafId = requestAnimationFrame(() => {
          // Read window.innerHeight in animation frame
          const vh = window.innerHeight * 0.01;
          // Write style in the same frame to batch operations
          document.documentElement.style.setProperty('--vh', `${vh}px`);
          ticking = false;
          rafId = null;
        });
        ticking = true;
      }
    };

    // Initial set with requestAnimationFrame
    requestAnimationFrame(setViewportHeight);
    
    window.addEventListener('resize', setViewportHeight, { passive: true });
    window.addEventListener('orientationchange', setViewportHeight, { passive: true });

    return () => {
      window.removeEventListener('resize', setViewportHeight);
      window.removeEventListener('orientationchange', setViewportHeight);
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
    };
  }, []);

  return null;
};

export default MobileScrollFix; 